import { Phone } from "lucide-react";

/**
 * 988 Suicide & Crisis Lifeline banner for depression / mental-health pages.
 *
 * Renders a visible, accessible crisis-resource callout. Place it on any
 * page that discusses depression, suicidal ideation, or mental-health
 * crises. The number and language are fixed (988 is the U.S. national
 * lifeline) so the component takes no props.
 *
 * Accessibility: the phone link uses tel: so it is tracked by the global
 * phone-click conversion listener; aria-label is explicit.
 */
export const CrisisLifelineBanner: React.FC<{ className?: string }> = ({
  className = "",
}) => (
  <aside
    role="note"
    aria-label="Crisis support"
    className={`flex items-center gap-3 rounded-lg border border-accent/30 bg-accent/10 px-4 py-3 ${className}`}
  >
    <Phone className="h-5 w-5 shrink-0 text-accent" aria-hidden />
    <p className="text-sm text-foreground">
      <span className="font-semibold">In a crisis?</span> Call or text{" "}
      <a
        href="tel:988"
        className="font-bold text-accent underline underline-offset-2"
        aria-label="Call or text 988 Suicide and Crisis Lifeline"
      >
        988
      </a>{" "}
      (the 988 Suicide & Crisis Lifeline) 24/7, or dial 911 if you or someone is
      in immediate danger.
    </p>
  </aside>
);

export default CrisisLifelineBanner;
